import type { PieChartCustomTooltipProps } from '../types/pie-chart.config.js';

/**
 * Tooltip slot component.
 */
export const Tooltip = (props: PieChartCustomTooltipProps) => null;

Tooltip['displayName'] = 'PieChart.Tooltip';
